import { useEffect, useMemo, useState } from "react";
import { Button } from "../../../components/button/button";
import { AdminHeader } from "../../../components/adminHeader/adminHeader";
import { useLocation, useParams } from "react-router";
import { ScrollableMenu } from "../../../components/scrollableMenu/scrollableMenu";
import { priorityRepeatTabs, workerRepeatTabs } from "./repeatTabs";
import { Retractable } from "../../../components/retractable/retractable";
import { Checkbox } from "../../../components/checkbox/checkbox.jsx";
import { useAnimatedNavigate } from "../../../hooks/useAnimatedNavigate";
import { InputBlock } from "./InputBlock.jsx";
import { PageLoader } from "../../../components/loader/pageLoader.jsx";
import { UploadFile } from "../../../components/uploadFile/uplodeFile.jsx";
import CheckListAPI from "../../../api/CheckListAPI.js";
import AdminAPI from "../../../api/AdminAPI";
import classNames from "classnames";
import qs from "qs";

import styles from "./workerTaskAddPage.module.css";

import { Text } from "../../../components/text/text";

export const WorkerTaskAddPage = () => {
    const { userId } = useParams();
    const { search } = useLocation();
    const searchParams = qs.parse(search.replace("?", ""));

    const [tabId, setTabId] = useState(null);

    const [description, setDescription] = useState("");
    const [descriptionError, setDescriptionError] = useState(false);

    const [steps, setSteps] = useState(1);
    const [stepsError, setStepsError] = useState(false);

    const [exp, setExp] = useState(0);
    const [expError, setExpError] = useState(false);

    const [isRepeating, setIsRepeating] = useState(false);
    const [repeat, setRepeat] = useState(workerRepeatTabs[0]);

    const [repeatDays, setRepeatDays] = useState(1);
    const [repeatDaysError, setRepeatDaysError] = useState(false);

    const [beginDate, setBeginDate] = useState(new Date());
    const [beginDateError, setBeginDateError] = useState(false);

    const [endDate, setEndDate] = useState(new Date());
    const [endDateError, setEndDateError] = useState(false);

    const [priority, setPriority] = useState(priorityRepeatTabs[0]);

    const [isXlsxFile, setIsXlsxFile] = useState(false);
    const [file, setFile] = useState(null);
    const [fileError, setFileError] = useState(false);

    const resetErrors = () => {
        setDescriptionError(false);
        setStepsError(false);
        setExpError(false);
        setRepeatDaysError(false);
        setBeginDateError(false);
        setEndDateError(false);
        setFileError(false);
    }

    const validateData = () => {
        let errors = false;

        if (!isXlsxFile) {
            if (description.length === 0) {
                setDescriptionError(true);
                errors = true;
            }

            if (steps === 0) {
                setStepsError(true);
                errors = true;
            }
        } else {
            if (!file) {
                setFileError(true);
                errors = true;
            }
        }

        if (repeatDays === 0) {
            setRepeatDaysError(true);
            errors = true;
        }

        const now = new Date();
        now.setHours(0, 0, 0, 0);
        if (beginDate.getTime() > endDate.getTime()) {
            setBeginDateError(true);
            setEndDateError(true);
            errors = true;
        }
        else if (beginDate.getTime() < now.getTime()) {
            setBeginDateError(true);
            errors = true;
        }
        else if (endDate.getTime() < now.getTime()) {
            setEndDateError(true);
            errors = true;
        }


        return errors;
    }

    const { cafeId } = useParams();

    const [employees, setEmployees] = useState([]);
    const [allEmployees, setAllEmployees] = useState([]);
    useEffect(() => {
        if (cafeId === null) return;
        AdminAPI
            .fetchCafeEmployees(cafeId)
            .then(res => setAllEmployees(res))
            .catch(console.error);
    }, [cafeId]);

    const [pageLoading, setPageLoading] = useState(true);
    const [checklistCategories, setChecklistCategories] = useState([]);
    useEffect(() => {
        CheckListAPI
            .fetchChecklistCategories(cafeId)
            .then((res) => {
                setChecklistCategories(res);
            })
            .catch(console.error)
            .finally(() => setPageLoading(false));
    }, [cafeId]);

    useEffect(() => {
        if (!tabId) {
            if (searchParams.initialTab) {
                setTabId(+searchParams.initialTab);
            } else if (checklistCategories[0]) {
                setTabId(+checklistCategories[0].id);
            }
        }
    }, [searchParams, checklistCategories, tabId]);

    const allFilteredEmployees = useMemo(
        () => allEmployees.filter(el => String(el.userId) !== String(userId)),
        [userId, allEmployees]
    );

    const navigate = useAnimatedNavigate();
    const [loading, setLoading] = useState(false);
    const onSave = async () => {
        resetErrors();
        if (!cafeId) return;
        if (validateData()) return;

        setLoading(true);
        try {
            if (!isXlsxFile) {
                await AdminAPI.createTask(
                    cafeId,
                    [...employees.map(el => el.userId), userId],
                    description,
                    isRepeating ? "reccurent" : "daily",
                    steps,
                    exp,
                    !isRepeating ? beginDate : null,
                    !isRepeating ? endDate : null,
                    isRepeating ? ((repeat.ownVariant) ? repeatDays : repeat.value) : null,
                    checklistCategories.find(el => el.id === tabId).text,
                    priority.value
                )
            } else {
                await AdminAPI.uploadChecklistXlsx(
                    cafeId,
                    file,
                    [...employees.map(el => el.userId), userId],
                    isRepeating ? "reccurent" : "daily",
                    !isRepeating ? beginDate : null,
                    !isRepeating ? endDate : null,
                    isRepeating ? ((repeat.ownVariant) ? repeatDays : repeat.value) : null,
                    exp,
                )
            }

            const query = qs.stringify({
                initialTab: tabId,
                initialDaily: !isRepeating,
            });

            navigate(`/admin/${cafeId}/cafe/employees/${userId}/tasks?${query}`);
        } catch (err) {
            console.error(err);
        }
        setLoading(false);
    }

    if (pageLoading) {
        return <PageLoader />;
    }

    return (
        <>
            <AdminHeader title="Задача для: " userId={userId} />

            <div className={styles.buttons}>
                <Button
                    text="Задать вручную"
                    view="thin"
                    type={!isXlsxFile ? "primary" : "secondary"}
                    onClick={() => setIsXlsxFile(false)}
                />
                <Button
                    text="Использовать файл"
                    view="thin"
                    type={isXlsxFile ? "primary" : "secondary"}
                    onClick={() => setIsXlsxFile(true)}
                />
            </div>

            {
                !isXlsxFile &&
                <Text as="div" variant="body" className="page_description" >
                    Выберите категорию и задайте параметры для новой задачи.
                </Text>
            }

            {
                !isXlsxFile &&
                <ScrollableMenu
                    buttons={checklistCategories}
                    current={tabId}
                    setCurrent={setTabId}
                />
            }

            <InputBlock
                type="user"
                title="Укажите сотрудников, которым Вы хотите дополнительно назначить задание"
                value={employees}
                values={allFilteredEmployees}
                setValue={setEmployees}
            />

            {
                isXlsxFile &&
                <div className={styles.input_block}>
                    <div className={classNames(styles.input_block_title, { [styles.error]: fileError })}>
                        Файл с задачами (xlsx)
                    </div>
                    <UploadFile
                        selectedFile={file}
                        setSelectedFile={setFile}
                        accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    />
                </div>
            }

            {
                !isXlsxFile &&
                <>
                    <InputBlock
                        type="text"
                        title="Кратко опишите задачу"
                        value={description}
                        setValue={setDescription}
                        error={descriptionError}
                    />

                    <InputBlock
                        type="number"
                        title="Установите количество шагов в задаче, например если продать нужно 5 десертов, поставьте в поле цифру 5"
                        value={steps}
                        setValue={setSteps}
                        error={stepsError}
                    />
                </>
            }

            <InputBlock
                type="number"
                title="Установите количество опыта, которое получит сотрудник при выполнении задачи"
                value={exp}
                setValue={setExp}
                error={expError}
            />

            {
                !isXlsxFile &&
                <div className={styles.input_block}>
                    <Text as="div" variant="caption" className={styles.input_block_title} >
                        Укажите приоритет задачи
                    </Text>
                    <div className={styles.repeat_tabs}>
                        {
                            priorityRepeatTabs.map(data => (
                                <div
                                    key={data.id}
                                    className={classNames(styles.repeat_tab, { [styles.active]: data.id === priority.id })}
                                    onClick={() => setPriority(data)}
                                >
                                    {data.text}
                                </div>
                            ))
                        }
                    </div>
                </div>
            }

            <div>
                <div className={styles.checkbox_container}>
                    <Checkbox
                        checked={isRepeating}
                        onChange={setIsRepeating}
                    />
                    <Text as="div" variant="body" className={styles.checkbox_text} size={12} lineHeight="1">
                        Повторяющаяся задача
                    </Text>
                </div>

                <Retractable active={!isRepeating}>
                    <div className={styles.dates}>
                        <InputBlock
                            type="date"
                            className={styles.start_date_input}
                            title="Дата начала"
                            value={beginDate.toISOString().split("T")[0]}
                            setValue={(val) => {
                                try {
                                    const newDate = new Date(val.split("T")[0]);
                                    newDate.toISOString();
                                    setBeginDate(newDate);
                                } catch {
                                    setBeginDate(prev => prev);
                                }
                            }}
                            error={beginDateError}
                        />

                        <InputBlock
                            type="date"
                            className={styles.start_date_input}
                            title="Дата конца"
                            value={endDate.toISOString().split("T")[0]}
                            setValue={(val) => {
                                try {
                                    const newDate = new Date(val.split("T")[0]);
                                    newDate.toISOString();
                                    setEndDate(newDate);
                                } catch {
                                    setEndDate(prev => prev);
                                }
                            }}
                            error={endDateError}
                        />
                    </div>
                </Retractable>

                <Retractable active={isRepeating}>
                    <div className={styles.repeat_tabs} style={{ marginTop: "14px" }}>
                        {
                            workerRepeatTabs.map(data => (
                                <div
                                    key={data.id}
                                    className={classNames(styles.repeat_tab, { [styles.active]: data.id === repeat.id })}
                                    onClick={() => setRepeat(data)}
                                >
                                    {data.text}
                                </div>
                            ))
                        }
                    </div>

                    <Retractable active={repeat.ownVariant}>
                        <InputBlock
                            min={1}
                            className={styles.repeat_days_input}
                            type="number"
                            title="Кол-во дней повтора"
                            value={repeatDays}
                            setValue={setRepeatDays}
                            error={repeatDaysError}
                        />
                    </Retractable>
                </Retractable>
            </div>

            <Button text="Сохранить" type="primary" onClick={onSave} disabled={loading} />
        </>
    )
}
